import { createActionGroup, emptyProps } from '@ngrx/store';

export const permissionGuardActions = createActionGroup({
  source: 'permissionGuard',
  events: {
    'Can Activate': emptyProps(),
  },
});
